import React, { Component } from 'react';
import { Navbar, NavbarBrand, Nav, NavItem } from 'reactstrap';

import config from '../../config';
import makeUrl from '../../lib/makeUrl';
import CustomLink from './Link';
import UserDropdown from './UserDropdown';
import FlightsDropdown from './FlightsDropdown';
import CartIcon from './Cart';

type Props = {
  userInfo: Object,
  history: Object,
};

const navBarMobileLogo = `${config.ASSETS_URL}/honeyguide.png`;
const styles = { menuList: { flexDirection: 'row' } };

export default class NavbarMobile extends Component<Props> {
  render() {
    const { userInfo } = this.props;
    const isUserLoggedIn = userInfo && Boolean(userInfo.userId);
    const { goToGuideListings, goToTreks, goToLodge, goToTransportation } = makeUrl;

    return (
      <Navbar color="faded" light className="bg-white mobile mobile-nav">
          <NavbarBrand className="mobile-brand" href="/">
            <img src={navBarMobileLogo} height="53" alt="navbar" />
          </NavbarBrand>
          <Nav className="menu-list" navbar style={styles.menuList}>
            <CustomLink linkTo={goToTreks} linkIcon="tour.svg" title="Tours"/>
            <FlightsDropdown mobile />
            <CustomLink linkTo={goToLodge} linkIcon="lodge.svg" title="Lodges"/>
            <CustomLink linkTo={goToGuideListings} linkIcon="guide.svg" useAnchor title="Guides"/>
            <CustomLink linkTo={goToTransportation} linkIcon="transport.svg" title="Transports"/>
            {/* <CartIcon /> */}
          </Nav>
          {/* <Nav className="mr-auto menu-list" navbar style={styles.menuList}>
            <FlightsDropdown />
            <CustomLink
              linkTo={goToLodge}
              linkIcon="icon-hg-house-of-rural-hotel"
            />
            <CustomLink
              linkTo={goToGuideListings}
              linkIcon="icon-hg-man-in-hike"
            />
            <CustomLink
              linkTo={goToTreks}
              linkIcon="icon-hg-profile-trek-old"
            />
             <CustomLink linkTo={goToTransportation} linkIcon="icon-hg-car" />
            <CartIcon />
          </Nav> */}
          <Nav className="menu-list" navbar style={styles.menuList}>
            <NavItem>
              <UserDropdown isUserLoggedIn={isUserLoggedIn} {...this.props} />
            </NavItem>
          </Nav>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/NavbarMobile.jsx